var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMailSquare = function SvgIconMailSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#1A1A1A",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 19.953C25 21.635 23.625 23 21.932 23H10.068C8.375 23 7 21.635 7 19.953v-9.476l6.831 6.784a3.08 3.08 0 0 0 4.339 0L25 10.477zM23.514 10l-6.935 6.887a.82.82 0 0 1-1.156 0L8.488 10z"
  })));
};
export default SvgIconMailSquare;